import { defineAsyncComponent } from 'vue';

export default {
	description: 'Производители',
	forms: {
		edit: {
			panel: {
				width: '50%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '50%',
				height: '60%'
			},
			config: {
				fields: {
					position_number: {},
					name: {}
				}
			}
		}
	}
};

